<template>
  <v-expansion-panels flat class="mt-1">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="d-flex align-center">
          <v-icon left>
            mdi-filter-variant
          </v-icon>

          Napredna pretraga
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-container fluid class="pa-0">

          <!-- BASIC FILTERS -->
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="filters.email"
                label="Email"
                clearable
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="filters.town"
                label="Grad"
                clearable
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="filters.status"
                :items="statusItems"
                label="Status"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>
          </v-row>

          <!-- REGISTRATION DATE -->
          <v-row>
            <v-col cols="12" md="3">
              <v-menu
                v-model="registrationDateFromMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDate(filters.registrationDateFrom)"
                    label="Datum registracije (Od)"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="filters.registrationDateFrom = null"
                  />
                </template>

                <v-date-picker
                  v-model="filters.registrationDateFrom"
                  @input="registrationDateFromMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="3">
              <v-menu
                v-model="registrationDateToMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDate(filters.registrationDateTo)"
                    label="Datum registracije (Do)"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="filters.registrationDateTo = null"
                  />
                </template>

                <v-date-picker
                  v-model="filters.registrationDateTo"
                  @input="registrationDateToMenu = false"
                />
              </v-menu>
            </v-col>

            <!-- ACTIVATION DATE -->
            <v-col cols="12" md="3">
              <v-menu
                v-model="activationDateFromMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDate(filters.activationDateFrom)"
                    label="Datum aktivacije (Od)"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="filters.activationDateFrom = null"
                  />
                </template>

                <v-date-picker
                  v-model="filters.activationDateFrom"
                  @input="activationDateFromMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="3">
              <v-menu
                v-model="activationDateToMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatDate(filters.activationDateTo)"
                    label="Datum aktivacije (Do)"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="filters.activationDateTo = null"
                  />
                </template>

                <v-date-picker
                  v-model="filters.activationDateTo"
                  @input="activationDateToMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <!-- SUBSCRIPTION FILTERS -->
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="filters.serviceType"
                :items="serviceTypeItems"
                label="Tip servisa"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="filters.plan"
                :items="planItems"
                label="Plan"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="filters.lastUsage"
                type="number"
                label="Poslednja aktivnost (dana)"
                clearable
                outlined
                dense
                min="0"
              />
            </v-col>
          </v-row>

          <!-- ACTION BUTTONS -->
          <v-row class="mt-2">
            <v-col
              cols="12"
              class="d-flex justify-end"
            >
              <v-btn
                class="mr-2"
                text
                @click="resetFilters"
              >
                Reset
              </v-btn>

              <v-btn
                color="primary"
                @click="applyFilters"
              >
                Primeni filtere
              </v-btn>
            </v-col>
          </v-row>

        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'CompanyFilters',

  data() {
    return {
      registrationDateFromMenu: false,
      registrationDateToMenu: false,

      activationDateFromMenu: false,
      activationDateToMenu: false,

      filters: {
        email: null,

        registrationDateFrom: null,
        registrationDateTo: null,

        activationDateFrom: null,
        activationDateTo: null,

        serviceType: null,
        town: null,
        status: null,
        plan: null,
        lastUsage: null
      },

      statusItems: [
        { text: 'Sve', value: null },
        { text: 'Aktivne', value: true },
        { text: 'Neaktivne', value: false }
      ],

      serviceTypeItems: [
        { text: 'eFakture', value: "eFakture" },
        { text: 'eOtpremnice', value: "eOtpremnice" },
        { text: 'Oba', value: "Both" }
      ],

      planItems: [
        { text: 'Trial', value: "Trial" },
        { text: 'Paid', value: "Paid" },
      ]
    }
  },

  methods: {
    applyFilters() {
      this.$emit('apply-filters', {
        ...this.filters
      })
    },

    resetFilters() {
      this.filters = {
        email: null,

        registrationDateFrom: null,
        registrationDateTo: null,

        activationDateFrom: null,
        activationDateTo: null,

        serviceType: null,
        town: null,
        status: null,
        plan: null,
        lastUsage: null
      }

      this.$emit('reset-filters')
    },

    formatDate(date) {
      if (!date)
        return ''

      return new Date(date).toLocaleDateString('sr-RS')
    }
  }
}
</script>

<style scoped>
</style>
